import { Component, Mixins } from 'vue-property-decorator';
import OrderGridsExcelDown from '@/components/common/order/mixins/OrderGridsExcelDown';
import { writeExcel } from '@/utils/excel';
import { i18nAllObject } from '@/utils/i18n';
import { getDownToday } from '@/utils/dateUtils';


@Component
export default class DeliveryPrepareGrids extends Mixins(OrderGridsExcelDown) {
  public gridProps: any = {
    header: {
      columns: [
        {
          name: 'exchange',
          renderer: (): any => {
            const el = document.createElement('div');
            const btn = document.createElement('button');
            btn.className = 'help';
            btn.id = 'exchangeHelpBtn';
            const onMousedown = (ev: any): any => {
              ev.stopPropagation();
            };
            btn.addEventListener('mousedown', onMousedown);
            return {
              getElement(): any {
                return el;
              },
              render(props: any): any {
                el.textContent = props.columnInfo.header;
                el.appendChild(btn);
              },
              beforeDestroy(): any {
                btn.removeEventListener('mousedown', onMousedown);
              }
            };
          }
        }
      ]
    },
    options: {
      header: {
        height: 33
      },
      rowHeaders: ['checkbox'],
      columnOptions: {
        minWidth: 50,
        resizable: true,
        frozenCount: 0
      },
      
      displayRowCount: 30,
      isInitialRequest: true,
      // keyColumnName: 'orderProductOptionNo',
      useClientSort: false,
      virtualScrolling: true,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      },
    },
    // showDummyRows: true,
    columns: []
  };

  public initProNoColums: any = [
    '배송번호',
    '배송메모',
    '수령자명',
    '수령자휴대전화',
    '우편번호',
    '주소',
    '개인통관고유부호',
    '배송방법',
    '택배사',
    '송장번호입력',
    '출고처리',
    '업무메시지',
    '교환여부',
    '배송구분',
    '쇼핑몰구분',
    '결제수단',
    '배송비 결제방식',
    '기본배송비',
    '지역별배송비',
    '플랫폼구분',
    '주문구분',
    '예약주문',
    '회원그룹',
    '주문번호',
    '주문자명',
    '주문자 연락처',
    '회원번호',
    '파트너사',
    'HS CODE',
    '상품번호',
    '상품관리코드',
    '상품 이미지',
    '상품명',
    '영문상품명',
    '옵션관리코드',
    '옵션명',
    '수량',
    '판매가(할인적용가)',
    '주문일시',
    '결제일시',
    '주문접수일시',
    '출고준비처리일시',
    '출고일시',
    '배송완료일시',
    '구매확정일시',
    '주문상품옵션번호',
    '정기결제(배송) 신청 번호',
    '적립금사용',
    '실결제금액',
  ];
  public initOrNoColums: any = [
    '플랫폼구분',
    '쇼핑몰구분',
    '주문구분',
    '예약주문',
    '회원그룹',
    '결제수단',
    '주문번호',
    '주문자명',
    '주문자 연락처',
    '회원번호',
    '교환여부',
    '배송구분',
    '업무메시지',
    '파트너사',
    'HS CODE',
    '상품번호',
    '상품관리코드',
    '상품 이미지',
    '상품명',
    '영문상품명',
    '옵션관리코드',
    '옵션명',
    '수량',
    '판매가(할인적용가)',
    '배송메모',
    '수령자명',
    '수령자휴대전화',
    '우편번호',
    '주소',
    '배송번호',
    '개인통관고유부호',
    '배송방법',
    '택배사',
    '송장번호',
    '배송비 결제방식',
    '기본배송비',
    '지역별배송비',
    '주문일시',
    '결제일시',
    '주문접수일시',
    '출고준비처리일시',
    '출고일시',
    '배송완료일시',
    '구매확정일시',
    '주문상품옵션번호',
    '정기결제(배송) 신청 번호',
    '적립금사용',
    '실결제금액',
  ];
  public invoiceExcelDown: any = {
    columns: {
      shippingNo: 'ORDER_LIST_GRIDS_HEADER_DELIVER_NO',
      receiverName: 'ORDER_LIST_GRIDS_HEADER_RECEIVER_NAME',
      receiverContact1: 'ORDER_LIST_GRIDS_HEADER_RECEIVER_CONTACT1',
      receiverZipCd: 'ORDER_LIST_GRIDS_HEADER_RECEIVER_ZIP_CD',
      address: 'ORDER_LIST_GRIDS_HEADER_ADRESS',
      customsIdNumber: 'ORDER_LIST_GRIDS_HEADER_CUSTOMS_ID_NUMBER',
      deliveryType: 'ORDER_LIST_GRIDS_HEADER_DELIVER_TYPE',
      invoiceNo: 'ORDER_LIST_GRIDS_HEADER_INVOICE_NO',
      orderYmdt: 'ORDER_LIST_GRIDS_HEADER_ORDER_YMDT',
      orderNo: 'ORDER_LIST_GRIDS_HEADER_ORDER_NO',
      ordererName: 'ORDER_LIST_GRIDS_HEADER_ORDER_NAME',
      productName: 'ORDER_LIST_GRIDS_HEADER_PRODUCT_NAME'
    },
    formatters: {
      deliveryType: (data: any): any => {
        if (data.value === null) {
          return '-';
        }
        return data.value;
      },
      invoiceNo: (data: any): any => {
        return data.value === null ? '-' : data.value;
      },
      orderNo: (data: any): any => {
        return data.value + (data.row.payType === 'NAVER_PAY' ? ` (N: ${data.row.externalOrderNo})` : '');
      },
      ordererName: (data: any): any => {
        return data.value;
      }
    }
  };
  public selectExcelInfo: any = {
    columns: {
      releaseType: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_RELEASE_TYPE', //是否固定为1
      payYmdt: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_PAY_YMDT',
      receiverZipCd: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_RECEIVER_ZIP_CD',
      address: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_ADDRESS', //
      receiverName: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_RECEIVER_NAME',
      receiverContact1: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_RECEIVER_CONTACT1',
      receiverContact2: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_RECEIVER_CONTACT2',
      deliveryMemo: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_DELIVERY_MEMO',
      orderMemo: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_ORDER_MEMO',
      releaseEmpty: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_RELEASE_EMPTY',
      shippingNo: 'ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_COLUMNS_SHIPPING_NO'
    },
    formatters: {},
    fileName: ''
  };
  public downloadAllInvoiceExcel(): any { }
  public downloadSelectedInvoiceExcel(data: any): any {
    if (data && data.length > 0) {
      let columns = i18nAllObject(this, this.selectExcelInfo.columns);
      let time = getDownToday().substring(0, 8);
      let downloadCount = 3; //之后查看 获取downloadCount
      let name: any = this.$t('ORDER_DELIVERY_PREPARE_EXCEL_DOWNLOAD_EXCEL_NAME', { time: time, count: downloadCount });
      writeExcel(data, columns, name, this.selectExcelInfo.formatters);
    } else {
      alert(this.$t('COMMON_NOT_DATA'));
    }
  }

  public isEmpty(value: any): boolean {
    return value == null || value === '';
  }
}
